import {
  Menu,
  Icon,
  Text,
  Box,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';

import { AccountSelectionHeaderProps } from 'types/plaid';

import { InvalidateItemModal } from 'borrower/domains/bankIntegrations/ui/plaid/InvalidateItemModal';
import { ImageWithFallback } from 'packages/common-frontend/components/ImageWithFallback';
import { defaultPlaidInstitutionLogo } from 'packages/common-frontend/constants';
import { FiSettings } from 'react-icons/fi';

export const AccountSelectionHeader = ({
  institutionWithAccounts,
  refreshAccounts,
}: AccountSelectionHeaderProps) => {
  const { logoUrl, name, itemId: plaidItemId } = institutionWithAccounts;
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Refresh button intentionally wrapped in span to resolve chakru-ui issue
  // https://github.com/chakra-ui/chakra-ui/issues/500
  return (
    <Box>
      <Box width="100%" d="flex" alignItems="center" justifyContent="left">
        <Box d="flex" alignItems="center">
          <ImageWithFallback
            fallbackUrl={defaultPlaidInstitutionLogo}
            height={32}
            width={32}
            defaultUrl={logoUrl}
            alt="Logo"
          />
          <Text fontWeight="bold" ml="10px">
            {name}
          </Text>
        </Box>
        <Box marginLeft="auto" marginRight="25px">
          <Menu>
            <MenuButton colorscheme="ghost">
              <Icon as={FiSettings} />
            </MenuButton>
            <MenuList>
              <MenuItem
                onClick={() => {
                  refreshAccounts();
                }}
              >
                Refresh Accounts
              </MenuItem>
              <MenuItem onClick={onOpen}>Remove Connection</MenuItem>
            </MenuList>
          </Menu>
          <InvalidateItemModal
            isOpen={isOpen}
            onClose={onClose}
            name={name}
            plaidItemId={plaidItemId}
          />
        </Box>
      </Box>
    </Box>
  );
};
